export default [
  {
    path: '/admin',
    name: 'Admin Layout',
    component: () => import('src/components/Core/AppLayout.vue'),
    children: []
  }
]
